import React from "react";
import { Link } from "react-router-dom";
import { CalendarCheck, CheckCircle2, Phone, MapPin, ArrowRight, Languages } from "lucide-react";
import { Button } from "../components/ui/button";
import { IMAGES, CONTACT, TRYOUT } from "../mock";
import Seo from "../components/Seo";

const PROGRAMAS = [
  ["Crianças pequenas (2,5–5 anos)", "Segunda 4:15 PM · Quarta 6:15 PM"],
  ["Little Warriors (4–9 anos)", "Segunda 6:00 PM"],
  ["Crianças (5–12 anos)", "Segunda a quinta 5:00–6:00 PM · Sábado 10:30 AM"],
  ["Crianças, adolescentes e adultos", "Terça e quinta 6:00–7:00 PM"],
  ["Adultos (todos os níveis)", "Segunda e quarta 6:00 AM · Segunda a quinta 7:00 PM · Sábado 9:30 AM"],
];

const Portugues = () => (
  <div className="pt-24">
    <Seo
      title="Jiu-Jitsu Brasileiro em Alameda — Primeira aula GRÁTIS | Falamos português e espanhol"
      description="Aulas de Jiu-Jitsu Brasileiro e defesa pessoal em Alameda, CA para crianças, adolescentes e adultos. O Professor Sergio Silva fala português e espanhol. Sua primeira aula é grátis."
      path="/pt"
      breadcrumb={[{ name: "Home", path: "/" }, { name: "Português", path: "/pt" }]}
    />
    <section className="relative overflow-hidden bg-[#0E1613] text-white">
      <img src={IMAGES.hero} alt="Jiu-Jitsu Brasileiro em Alameda" className="absolute inset-0 h-full w-full object-cover opacity-30" />
      <div className="relative max-w-5xl mx-auto px-5 lg:px-8 py-16 sm:py-24">
        <span className="inline-flex items-center gap-2 rounded-full bg-br-yellow text-[#1A1A1A] px-4 py-1.5 text-xs font-bold tracking-wide" data-testid="pt-badge">
          <Languages size={14} /> O Professor Sergio Silva fala português e espanhol
        </span>
        <h1 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight">
          Jiu-Jitsu Brasileiro e Defesa Pessoal em Alameda
        </h1>
        <p className="mt-5 text-lg text-neutral-200 max-w-2xl">
          Aulas para crianças, adolescentes e adultos com o Professor Sergio Silva, faixa preta 5.º grau e campeão mundial, brasileiro radicado em Alameda. Não precisa de experiência. <strong className="text-white">Sua primeira aula é GRÁTIS.</strong>
        </p>
        <Link to="/trial" data-testid="pt-free-class-btn" className="inline-block mt-8 w-full sm:w-auto">
          <Button className="w-full sm:w-auto h-14 px-10 bg-br-green hover:bg-[#00822f] text-white rounded-full text-base sm:text-lg font-extrabold">
            <CalendarCheck size={20} className="mr-2" /> AGENDE SUA AULA GRÁTIS
          </Button>
        </Link>
        <p className="mt-4 text-sm text-neutral-300">
          Prefere falar com alguém? Ligue ou mande mensagem para <a href={CONTACT.phoneHref} className="text-br-yellow font-semibold">{CONTACT.phone}</a> — em português, español ou English. <Link to="/es" className="underline">Versión en español</Link>
        </p>
      </div>
    </section>

    <section className="section-pad bg-[#F4F5F1]">
      <div className="max-w-5xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-8">
        <div className="bg-white rounded-2xl border border-neutral-100 p-7">
          <h2 className="font-display text-2xl font-bold text-[#1A1A1A]">Como funciona a aula grátis?</h2>
          <ul className="mt-4 space-y-3 text-neutral-700">
            {["Agende online em um minuto (nome, e-mail, telefone e programa).", "Venha de calça de moletom e camiseta — o resto é por nossa conta.", "Chegue 10 minutos antes. Os pais podem assistir à aula.", "Sem compromisso e sem pagamento. Depois você decide se quer continuar."].map((t) => (
              <li key={t} className="flex items-start gap-2.5"><CheckCircle2 size={18} className="text-br-green shrink-0 mt-0.5" /> {t}</li>
            ))}
          </ul>
          <div className="mt-6 rounded-xl bg-br-yellow/15 border border-br-yellow/40 p-4">
            <p className="font-semibold text-[#1A1A1A]">Oferta para novos alunos: {TRYOUT.price}</p>
            <p className="text-sm text-neutral-700 mt-1">Um mês de treino, 2 aulas por semana e kimono GRÁTIS. Pagamento único, sem renovação automática. Pague com Venmo, PayPal ou Zelle.</p>
            <Link to="/tryout" className="inline-flex items-center gap-1 mt-2 text-sm font-bold text-br-green" data-testid="pt-tryout-link">Ver a oferta de {TRYOUT.price} <ArrowRight size={14} /></Link>
          </div>
        </div>
        <div className="bg-white rounded-2xl border border-neutral-100 p-7">
          <h2 className="font-display text-2xl font-bold text-[#1A1A1A]">Programas e horários</h2>
          <ul className="mt-4 divide-y divide-neutral-100">
            {PROGRAMAS.map(([p, h]) => (
              <li key={p} className="py-3">
                <p className="font-semibold text-[#1A1A1A]">{p}</p>
                <p className="text-sm text-neutral-600">{h}</p>
              </li>
            ))}
          </ul>
          <div className="mt-5 space-y-2 text-sm text-neutral-700">
            <p className="flex items-center gap-2"><MapPin size={16} className="text-br-green" /> {CONTACT.addressShort} ({CONTACT.addressNote})</p>
            <p className="flex items-center gap-2"><Phone size={16} className="text-br-green" /> <a href={CONTACT.phoneHref} className="font-semibold text-br-green">{CONTACT.phone}</a> · {CONTACT.email}</p>
          </div>
        </div>
      </div>
      <div className="max-w-5xl mx-auto px-5 lg:px-8 mt-10 text-center">
        <Link to="/trial" data-testid="pt-free-class-btn-2">
          <Button className="h-13 py-6 px-10 bg-br-green hover:bg-[#00822f] text-white rounded-full text-base font-extrabold">
            <CalendarCheck size={18} className="mr-2" /> AGENDE SUA AULA GRÁTIS
          </Button>
        </Link>
        <p className="mt-3 text-xs text-neutral-500">O formulário está em inglês — se preferir, ligue e nós agendamos para você em português.</p>
      </div>
    </section>
  </div>
);

export default Portugues;
